import { Response } from "../types/Response.interface";
import axios from "axios";

export const apiClient = axios.create({
  baseURL: "https://api.bungalowfinder.ca",
});
// export const apiClient = axios.create({
//   baseURL: "http://127.0.0.1:2000",
// });
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (!token) return config;
    if (config.headers) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


apiClient.interceptors.response.use(
  (res) => {
    const _res: any = {
      ok: true,
      data: res.data,
      status: res.status,
    };

    return _res;
  },
  (error) => {
    let res: Response | undefined = undefined;

    if (error.response) {
      let _message: string[] = [];

      _message.push(error.response.data.message);

      res = {
        status: error.response.status,
        error: "SERVER",
        message: _message,
        data: error.response.data,
        ok: false,
      };

      if (res.status === 401) {
        localStorage.removeItem("token");
        window.dispatchEvent(new CustomEvent("unauth"));
      }
      return Promise.resolve(res);
    }

    if (error.request) {
      res = {
        status: 500,
        data: error.request,
        error: "CLIENT",
        message: error.message,
        ok: false,
      };

      return Promise.resolve(res);
    }

    res = {
      status: 500,
      data: {},
      ok: false,
      error: "ANY",
      message: ["Internal Server Error"],
    };

    return Promise.resolve(res);
  }
);
